import React, { memo } from "react";
import { StyledCheckbox as Checkbox } from "@/react/components/styled/StyledCheckbox";

export default function selectColumnFactory(options = null) {
  // Used for shift-click selection
  let lastSelectedId = null;

  return {
    id: "select",
    header: ({ table }) => (
      <SelectCheckboxHeader
        isDisabled={options?.disableHeaderControls ?? false}
        isAllRowsSelected={table.getIsAllRowsSelected()}
        isSomeRowsSelected={table.getIsSomeRowsSelected()}
        toggleAllRowsSelected={table.toggleAllRowsSelected}
      />
    ),
    cell: ({ row, table }) =>
      row.getCanSelect() && (
        <SelectCheckboxCell
          rowId={row.id}
          rowIsSelected={row.getIsSelected()}
          rowIsSomeSelected={row.getIsSomeSelected()}
          rowToggleSelected={row.toggleSelected}
          rows={table.getRowModel().rows}
          rowsById={table.getRowModel().rowsById}
          lastSelectedId={lastSelectedId}
          setLastSelectedId={(id) => {
            lastSelectedId = id;
          }}
        />
      ),
    size: 30,
    enableHiding: false,
    enableSorting: false,
    enableDownload: false,
    enableResizing: false,
    sticky: true,
  };
}

const SelectCheckboxHeader = memo(
  ({
    isAllRowsSelected,
    isSomeRowsSelected,
    toggleAllRowsSelected,
    isDisabled,
  }) => (
    <Checkbox
      isDisabled={isDisabled}
      isChecked={isAllRowsSelected}
      isIndeterminate={isSomeRowsSelected}
      onChange={() => toggleAllRowsSelected()}
      testId="all-select-checkbox"
    />
  )
);

export const SelectCheckboxCell = memo(
  ({
    rowId,
    rowIsSelected,
    rowIsSomeSelected,
    rowToggleSelected,
    // Needed for fast lookup by index
    rows,
    // Needed for fast lookup by id
    rowsById,
    lastSelectedId,
    setLastSelectedId,
  }) => (
    <Checkbox
      isChecked={rowIsSelected}
      isIndeterminate={rowIsSomeSelected}
      onChange={() => rowToggleSelected()}
      onClick={(e) => {
        if (e.shiftKey && lastSelectedId) {
          const currentRow = rowsById[rowId];
          const lastSelectedRow = rowsById[lastSelectedId];
          const isLastSelected = lastSelectedRow.getIsSelected();

          const startIndex = currentRow.index;
          const endIndex = lastSelectedRow.index;

          const rowsToToggle = rows.slice(
            Math.min(startIndex, endIndex),
            Math.max(startIndex, endIndex) + 1
          );

          rowsToToggle.forEach((row) => row.toggleSelected(isLastSelected));
        }
        setLastSelectedId(rowId);
      }}
      role="checkbox"
      testId="row-select-checkbox"
    />
  )
);
